import { ReactNode } from "react";
import { Menu, Button } from "@mantine/core";
import { STYLE } from "../../types/constants";

type ButtonMenuProps = {
  title: ReactNode;
  data: {
    onClick: any;
    content: ReactNode;
  }[];
};

export const ButtonMenu = ({ title, data }: ButtonMenuProps) => {
  return (
    <Menu>
      <Menu.Target>
        <Button style={{ backgroundColor: STYLE.primary }}>{title}</Button>
      </Menu.Target>
      <Menu.Dropdown>
        {(data ?? []).map((item, index: number) => {
          return (
            <Menu.Item key={index} onClick={item.onClick}>
              {item.content}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};
